import * as React from 'react';

interface IProps extends React.SVGProps<SVGSVGElement> {
  color?: string;
  size?: number;
}

/**
 * Matches the rendered stroke weight of the `@untitledui` icons this sits
 * beside. Those are drawn on a 24-unit grid at 1.7 (see `createIcon`); the same
 * weight on this 15-unit grid is that stroke scaled by the ratio of the grids,
 * which holds at every rendered size rather than at one.
 */
const STROKE_WIDTH = 1.7 * (15 / 24);

export const BillIcon: React.FC<IProps> = ({ color = 'currentColor', size = 14, ...props }) => {
  const aspectRatio = 15 / 14;
  const height = size * aspectRatio;

  return (
    <svg width={size} height={height} viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.2002 7.44995H3.7002M5.2002 10.45H3.7002M9.7002 4.44995H3.7002M12.7002 14.2V4.29995C12.7002 3.03983 12.7002 2.40977 12.455 1.92847C12.2392 1.50511 11.895 1.1609 11.4717 0.945187C10.9904 0.699951 10.3603 0.699951 9.1002 0.699951H4.3002C3.04008 0.699951 2.41002 0.699951 1.92872 0.945187C1.50535 1.1609 1.16115 1.50511 0.945431 1.92847C0.700195 2.40977 0.700195 3.03983 0.700195 4.29995V14.2L2.7627 12.7L4.6377 14.2L6.7002 12.7L8.7627 14.2L10.6377 12.7L12.7002 14.2Z"
        stroke={color}
        strokeWidth={STROKE_WIDTH}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default BillIcon;
